import { z } from "zod";

export const RequestPartnerAddressDtoSchema = z.object({
    addressType: z.string().nullish(),
    addressStreet: z.string().nullish(),
    addressStreetNumber: z.string().nullish(),
    addressCity: z.string().nullish(),
    addressPostCode: z.string().nullish(),
    addressCountry: z.string().nullish(),
    addressToShow: z.string().nullish(),
    addressToSave: z.string().nullish(),
});

export type RequestPartnerAddressDto = z.infer<typeof RequestPartnerAddressDtoSchema>;